<button tsl-icon-button size="large" (click)="close()">
  <tsl-icon>close</tsl-icon>
</button>
<!-- <div class="title" *ngIf="fileName">
    <h3 class="mb-3">
      {{fileName}}
    </h3>
  </div> -->
<pdf-viewer [src]="pdfSrc" [zoom]="1.2" (after-load-complete)="loadCompleted()"></pdf-viewer>
